// class-registry.ts

const nameMap = new WeakMap<Function, string>();

export class ClassRegistry {
  private static classMap = new Map<string, new (...args: any[]) => any>();

  static register(name: string, clazz: new (...args: any[]) => any) {
    if (this.classMap.has(name)) {
      throw new Error(`Class '${name}' already registered.`);
    }
    this.classMap.set(name, clazz);
    nameMap.set(clazz, name);
  }

  static get<T = any>(name: string): (new (...args: any[]) => T) | undefined {
    return this.classMap.get(name);
  }

  static keys(): string[] {
    return Array.from(this.classMap.keys());
  }

  static entries(): [string, string][] {
    return Array.from(this.classMap.entries()).map(([key, clazz]) => [
      key,
      clazz.name,
    ]);
  }

  static exportToJson(): string {
    return JSON.stringify(this.entries(), null, 2);
  }

  static getNameOf(clazz: Function): string | undefined {
    return nameMap.get(clazz);
  }
}

export function Register(name: string): ClassDecorator {
  return function (target: Function) {
    ClassRegistry.register(name, target as any);
  };
}
